import { createContext, useContext } from 'react';
import type { Company } from '../services/api';

interface CompanyWorkspaceContextValue {
  company: Company | null;
  companies: Company[];
  updateCompanyAppearance: (appearance: Pick<Company, 'name' | 'logo'>) => void;
}

export const CompanyWorkspaceContext = createContext<CompanyWorkspaceContextValue | null>(null);

export function useCompanyWorkspace() {
  return useContext(CompanyWorkspaceContext);
}
